<template>
  <Container title="订单管理">
    <!-- ★ 新增：最外层 flex 容器，锁定高度 -->
    <div class="flex-page-layout">
      
      <!-- 搜索卡片 -->
      <el-card shadow="never" class="search-card" style="width: 100%;">
        <el-form :model="searchForm" label-position="left" label-width="70px" ref="formName" @submit.prevent @keyup.enter="search">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="6" :lg="6" v-if="isSuperAdmin">
              <el-form-item label="企业" prop="enterpriseId">
                <el-select v-model="searchForm.enterpriseId" placeholder="请选择企业" clearable style="width: 100%;" @change="handleEnterpriseChange">
                  <el-option v-for="item in enterpriseList" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" :lg="6" v-if="isSuperAdmin">
              <el-form-item label="站点" prop="stationId">
                <el-select v-model="searchForm.stationId" placeholder="请选择站点" clearable filterable style="width: 100%;" :disabled="!searchForm.enterpriseId">
                  <el-option v-for="item in stationOptions" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" :lg="6">
              <el-form-item label="订单号" prop="order_no">
                <el-input clearable v-model="searchForm.order_no" placeholder="搜索订单号" style="width: 100%;" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" :lg="6">
              <el-form-item label="支付渠道" prop="channel">
                <el-select v-model="searchForm.channel" placeholder="请选择" clearable style="width: 100%;">
                  <el-option label="微信支付" value="wechat" />
                  <el-option label="支付宝支付" value="alipay" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" :lg="6">
              <el-form-item label="订单状态" prop="status">
                <el-select v-model="searchForm.status" placeholder="请选择" clearable style="width: 100%;">
                  <el-option label="支付成功" value="success" />
                  <el-option label="未支付" value="pending" />
                  <el-option label="支付失败" value="failed" />
                  <el-option label="已退款" value="refund" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" :lg="6">
              <el-form-item label="退款状态" prop="refund_status">
                <el-select v-model="searchForm.refund_status" placeholder="请选择" clearable style="width: 100%;">
                  <el-option label="待审批" value="applying" />
                  <el-option label="已批准待退款" value="approved" />
                  <el-option label="已拒绝" value="rejected" />
                  <el-option label="已退款" value="refunded" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" :lg="6">
              <el-form-item label="手机号" prop="phone">
                <el-input clearable v-model="searchForm.phone" placeholder="搜索手机号" style="width: 100%;" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" :lg="6">
              <el-form-item label="支付时间" prop="pay_time_range">
                <el-date-picker v-model="searchForm.pay_time_range" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="x" :shortcuts="shortcuts" style="width: 100%;" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" :lg="6" style="display: flex; justify-content: flex-end;">
              <el-form-item label=" " label-width="0" style="width: 100%;">
                <div style="display: flex; gap: 8px; width: 100%; justify-content: flex-end;">
                  <el-button type="primary" @click="search">查询</el-button>
                  <el-button @click="reset">重置</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>

      <!-- 表格卡片 -->
      <el-card shadow="never" class="table-card" style="width: 100%;">
        <template #header>
          <div class="table-header">
            <div class="table-header-left"></div>
            <div class="table-header-right">
              <el-tooltip content="刷新" placement="bottom"><el-button circle @click="refresh"><el-icon><Refresh /></el-icon></el-button></el-tooltip>
              <el-tooltip content="导出" placement="bottom"><el-button circle @click="handleExport"><el-icon><Download /></el-icon></el-button></el-tooltip>
              <el-tooltip content="打印" placement="bottom"><el-button circle @click="handlePrint"><el-icon><Printer /></el-icon></el-button></el-tooltip>
            </div>
          </div>
        </template>

        <!-- ★ 新增：表格外层容器，限制溢出 -->
        <div class="table-container">
          <el-table
            :data="tableData"
            border
            stripe
            :header-cell-style="stt"
            style="width: 100%"
            show-summary
            :summary-method="getSummaries"
            height="100%" 
          >
            <el-table-column prop="order_no" label="订单编号" min-width="220" show-overflow-tooltip />
            <el-table-column prop="station_name" label="站点" min-width="140" show-overflow-tooltip />
            <el-table-column prop="weight" label="重量(KG)" min-width="100" align="right" />
            <el-table-column prop="original_unit_price" label="原单价" min-width="100" align="right" />
            <el-table-column prop="settlement_unit_price" label="结算单价" min-width="100" align="right" />
            <el-table-column prop="final_unit_price" label="最终单价" min-width="100" align="right" />
            <el-table-column prop="original_amount" label="原金额" min-width="110" align="right" />
            <el-table-column prop="discount_amount" label="优惠金额" min-width="100" align="right" />
            <el-table-column prop="settlement_amount" label="结算金额" min-width="110" align="right" />
            <el-table-column prop="paid_amount" label="实付金额" min-width="110" align="right" />
            <el-table-column v-if="canViewWithdrawAmount" prop="withdraw_amount" label="可提现金额" min-width="120" align="right">
              <template #default="{ row }">¥{{ Number(row.withdraw_amount || 0).toFixed(3) }}</template>
            </el-table-column>
            <el-table-column prop="channel" label="支付渠道" min-width="100" align="center">
              <template #default="{ row }">{{ row.channel === 'wechat' ? '微信支付' : row.channel === 'alipay' ? '支付宝支付' : row.channel }}</template>
            </el-table-column>
            <el-table-column prop="status" label="订单状态" min-width="100" align="center">
              <template #default="{ row }">
                <el-tag :type="row.status === 'success' ? 'success' : row.status === 'pending' ? 'warning' : row.status === 'refund' ? 'info' : 'danger'">
                  {{ row.status === 'success' ? '支付成功' : row.status === 'pending' ? '未支付' : row.status === 'refund' ? '已退款' : '支付失败' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="pay_time" label="支付时间" min-width="160">
              <template #default="{ row }">{{ formatTime(row.pay_time) }}</template>
            </el-table-column>
            <el-table-column prop="refund_status" label="退款状态" min-width="110" align="center">
              <template #default="{ row }">
                <el-tag v-if="getRefundStatus(row) === 'applying'" type="warning" size="small">待审批</el-tag>
                <el-tag v-else-if="getRefundStatus(row) === 'approved'" type="primary" size="small">待退款</el-tag>
                <el-tag v-else-if="getRefundStatus(row) === 'rejected'" type="info" size="small">已拒绝</el-tag>
                <el-tag v-else-if="getRefundStatus(row) === 'refunded'" type="success" size="small">已退款</el-tag>
                <span v-else style="color:#c0c4cc;">-</span>
              </template>
            </el-table-column>
            <el-table-column prop="refund_time" label="退款时间" min-width="160">
              <template #default="{ row }">{{ formatTime(row.refund_time) }}</template>
            </el-table-column>
            <el-table-column label="操作" width="260" fixed="right" align="center">
              <template #default="{ row }">
                <el-button link type="primary" @click="openOrderDetail(row)">详情</el-button>
                <el-button v-if="canApplyRefund(row)" link type="warning" @click="handleApplyRefund(row)">{{ getRefundStatus(row) === 'rejected' ? '重新申请' : '申请退款' }}</el-button>
                <el-dropdown v-if="getRefundStatus(row) === 'applying' && canApprove(row)" trigger="hover" @command="(cmd) => handleApproveCommand(row, cmd)" style="margin-left: 8px; vertical-align: middle;">
                  <el-button type="warning" size="small" plain>审批<el-icon class="el-icon--right"><ArrowDown /></el-icon></el-button>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item command="pass"><el-icon><Select /></el-icon> 通过</el-dropdown-item>
                      <el-dropdown-item command="reject" divided><el-icon><CloseBold /></el-icon> 驳回</el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
                <el-button v-if="getRefundStatus(row) === 'approved' && canRefundExecute(row)" link type="danger" @click="handleRefund(row)">退款</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination-wrapper">
          <el-pagination @current-change="pageChange" @size-change="onSizeChange" v-model:current-page="page.current" v-model:page-size="page.pageSize" :total="page.total" background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[15, 40, 50, 100]" />
        </div>
      </el-card>

    </div>
    
    <!-- 弹窗部分保持不变，直接复制你原有的导出弹窗和详情弹窗代码... -->
    <ExportDialog v-model:visible="exportDialogVisible" :fields="visibleExportFields" :export-api="exportApi" :get-search-params="getSearchParams" :current-page="page" :default-file-name="defaultFileName()" />
    
    <el-dialog v-model="detailVisible" title="订单详情" width="620px" :close-on-click-modal="false">
      <el-descriptions :column="2" border v-if="detailOrder">
        <el-descriptions-item label="订单编号" :span="2">{{ detailOrder.order_no }}</el-descriptions-item>
        <el-descriptions-item label="站点">{{ detailOrder.station_name || '-' }}</el-descriptions-item>
        <el-descriptions-item label="支付渠道">{{ detailOrder.channel === 'wechat' ? '微信支付' : detailOrder.channel === 'alipay' ? '支付宝支付' : (detailOrder.channel || '-') }}</el-descriptions-item>
        <el-descriptions-item label="重量(KG)">{{ detailOrder.weight || 0 }}</el-descriptions-item>
        <el-descriptions-item label="实付金额">￥{{ Number(detailOrder.paid_amount || 0).toFixed(2) }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">
          <div style="display: flex; align-items: center; gap: 8px;">
            <el-tag :type="detailOrder.status === 'success' ? 'success' : detailOrder.status === 'pending' ? 'warning' : detailOrder.status === 'refund' ? 'info' : 'danger'">
              {{ detailOrder.status === 'success' ? '支付成功' : detailOrder.status === 'pending' ? '未支付' : detailOrder.status === 'refund' ? '已退款' : '支付失败' }}
            </el-tag>
            <el-button v-if="canSyncStatus(detailOrder)" size="small" type="primary" link :loading="syncingStatus" @click="syncOrderStatus(detailOrder)">同步状态</el-button>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="退款状态">
          <el-tag v-if="detailOrder.refund_status === 'applying'" type="warning">待审批</el-tag>
          <el-tag v-else-if="detailOrder.refund_status === 'approved'" type="primary">已批准待退款</el-tag>
          <el-tag v-else-if="detailOrder.refund_status === 'rejected'" type="info">已拒绝</el-tag>
          <el-tag v-else-if="detailOrder.refund_status === 'refunded'" type="success">已退款</el-tag>
          <span v-else>-</span>
        </el-descriptions-item>
        <el-descriptions-item label="支付时间" :span="2">{{ formatTime(detailOrder.pay_time) || '-' }}</el-descriptions-item>
        <el-descriptions-item label="退款原因" :span="2" v-if="detailOrder.refund_reason">{{ detailOrder.refund_reason }}</el-descriptions-item>
        <el-descriptions-item label="拒绝原因" :span="2" v-if="detailOrder.refund_reject_reason">{{ detailOrder.refund_reject_reason }}</el-descriptions-item>
        <el-descriptions-item label="申请时间" v-if="detailOrder.refund_apply_time">{{ formatTime(detailOrder.refund_apply_time) }}</el-descriptions-item>
        <el-descriptions-item label="审批时间" v-if="detailOrder.refund_approve_time">{{ formatTime(detailOrder.refund_approve_time) }}</el-descriptions-item>
        <el-descriptions-item label="退款时间" v-if="detailOrder.refund_time">{{ formatTime(detailOrder.refund_time) }}</el-descriptions-item>
      </el-descriptions>
      <template #footer><el-button @click="detailVisible = false">关闭</el-button></template>
    </el-dialog>
  </Container>
</template>

<script>
import { pub } from '/common/event';
import moment from 'moment';
import {
  Refresh,
  Download,
  Printer,
  ArrowDown,
  Select,
  CloseBold
} from '@element-plus/icons-vue';
import ExportDialog from '@/components/container/ExportDialog.vue';
import exportMixin from '@/mixins/exportMixin';
import { dateShortcuts } from '../../../utils/shortcuts.js';
import Container from '../../../components/container/Container.vue';
import enterpriseStationMixin from '@/mixins/enterpriseStationMixin';

export default {
  components: {
    Refresh,
    Download,
    Printer,
    ArrowDown,
    Select,
    CloseBold,
    ExportDialog,
    Container
  },
  mixins: [exportMixin, enterpriseStationMixin],
  data: () => ({
    searchForm: {
      enterpriseId: '',
      stationId: '',
      order_no: '',
      channel: '',
      status: '',
      refund_status: '',
      phone: '',
      merchant_id: '',
      pay_time_range: []
    },
    tableData: [],
    page: { current: 1, pageSize: 15, total: 0 },
    stt: { background: "#209cd111", color: "#209cd1" },
    shortcuts: dateShortcuts,
    exportFields: [
      { key: 'order_no', label: '订单编号', checked: true },
      { key: 'station_name', label: '站点', checked: true },
      { key: 'weight', label: '重量(KG)', checked: true },
      { key: 'original_unit_price', label: '原单价', checked: true },
      { key: 'settlement_unit_price', label: '结算单价', checked: true },
      { key: 'final_unit_price', label: '最终单价', checked: true },
      { key: 'original_amount', label: '原金额', checked: true },
      { key: 'discount_amount', label: '优惠金额', checked: true },
      { key: 'settlement_amount', label: '结算金额', checked: true },
      { key: 'paid_amount', label: '实付金额', checked: true },
      { key: 'withdraw_amount', label: '可提现金额', checked: true },
      { key: 'channel_label', label: '支付渠道', checked: true },
      { key: 'status_label', label: '订单状态', checked: true },
      { key: 'pay_time_label', label: '支付时间', checked: true },
	  { key: 'refund_status_label', label: '退款状态', checked: true },
      { key: 'refund_time_label', label: '退款时间', checked: true },
      { key: 'created_at_label', label: '创建时间', checked: true },
    ],
    exportDialogVisible: false,

    detailVisible: false,
    detailOrder: null,
	syncingStatus: false,
  }),
  computed: {
    isSuperAdmin() {
      const user = this.$store.state.user.user;
      return user && user.role === 'super_admin';
    },
    exportApi() { return this.$api.orders.export; },
    currentUser() {
      return this.$store.state.user.user || {};
    },
	canViewWithdrawAmount() {
	    const user = this.currentUser;
	    if (!user || !user.role) return false;
	    return ['super_admin', 'station_leader'].includes(user.role);
	  },
    // ★ 新增：根据权限动态过滤导出字段，不篡改原 exportFields
    visibleExportFields() {
      if (this.canViewWithdrawAmount) return this.exportFields;
      return this.exportFields.filter(f => f.key !== 'withdraw_amount');
    },
  },
  mounted() {
    const startOfDay = moment().startOf('day').valueOf();
    const endOfDay = moment().endOf('day').valueOf();
    this.searchForm.pay_time_range = [startOfDay, endOfDay];
    this.getData();
  },
  methods: {
    defaultFileName() {
      return '订单数据';
    },
    handleExport() {
      this.openExportDialog();
    },
    formatTime(ts) {
      if (!ts) return '';
      if (ts.toString().length === 10) ts = ts * 1000;
      return moment(ts).format('YYYY-MM-DD HH:mm:ss');
    },
    filterWhere() {
      const whereform = { ...this.searchForm };
      if (whereform.pay_time_range && whereform.pay_time_range.length === 2) {
        whereform.startTime = whereform.pay_time_range[0];
        whereform.endTime = whereform.pay_time_range[1];
        delete whereform.pay_time_range;
      }
      for (let k in whereform) {
        const val = whereform[k];
        if (val === '' || val === null || val === undefined || (Array.isArray(val) && val.length === 0)) {
          delete whereform[k];
        }
      }
      return { current: this.page.current, pageSize: this.page.pageSize, ...whereform };
    },
    async getData() {
      const where = this.filterWhere();
      try {
        const ret = await this.$api.orders.page(where);
        if (ret && ret.success) {
          const list = ret.data.data || [];
          list.forEach(item => {
            if (!item.refund_status) item.refund_status = 'none';
          });
          this.tableData = list;
          this.page.total = ret.data.total || 0;
        } else {
          pub('error_message', ret?.message || '加载数据失败');
        }
      } catch (error) {
        console.error('获取订单数据异常:', error);
        pub('error_message', '请求失败，请重试');
      }
    },
    refresh() { this.getData(); },
    pageChange(e) { this.page.current = e; this.getData(); },
    onSizeChange() { this.page.current = 1; this.getData(); },
    reset() {
      this.searchForm = {
        enterpriseId: '',
        stationId: '',
        order_no: '',
        channel: '',
        status: '',
        refund_status: '',
        phone: '',
        merchant_id: '',
        pay_time_range: []
      };
      this.stationOptions = [];
      this.$refs["formName"]?.resetFields();
      this.page.current = 1;
      this.getData();
    },
    search() { this.page.current = 1; this.getData(); },
    handlePrint() { window.print(); },

	canSyncStatus(row) {
	  if (!row) return false;
	  if (row.status === 'success' || row.status === 'refund') return false;
	  const rs = this.getRefundStatus(row);
	  if (['applying', 'approved', 'rejected', 'refunded'].includes(rs)) return false;
	  return true;
	},

	async syncOrderStatus(row) {
	  this.syncingStatus = true;
	  try {
		const res = await this.$api.orders.queryStatus(row.order_no);
		if (res && res.success) {
		  if (res.data.status === 'success') {
			this.$message.success('同步成功，该订单已支付！');
			this.detailOrder = { ...this.detailOrder, ...res.data };
			this.getData();
		  } else {
			this.$message.warning('支付渠道返回该订单依然是未支付状态');
		  }
		} else {
		  this.$message.error(res?.message || '同步失败');
		}
	  } catch (e) {
		console.error('同步状态异常:', e);
		this.$message.error('请求异常，请稍后重试');
	  } finally {
		this.syncingStatus = false;
	  }
	},

    getRefundStatus(row) {
      const rs = row && row.refund_status;
      if (!rs || rs === 'none' || rs === 'null' || rs === 'undefined') return 'none';
      return rs;
    },

    canApplyRefund(row) {
      if (!row || row.status !== 'success') return false;
      const rs = this.getRefundStatus(row);
      if (rs !== 'none' && rs !== 'rejected') return false;
      const user = this.currentUser;
      if (!user || !user.role) return false;
      if (['super_admin', 'admin', 'station_leader'].includes(user.role)) return true;
      return false;
    },

    canApprove(row) {
      const user = this.currentUser;
      if (!user || !user.role) return false;
      if (user.role === 'super_admin') return true;
      if (user.role === 'admin') {
        if (!user.station_id) return true;
        return user.station_id === row.station_id;
      }
      return false;
    },

    canRefundExecute(row) {
      const user = this.currentUser;
      if (!user || !user.role) return false;
      if (user.role === 'super_admin') return true;
      if (user.role === 'admin') {
        if (!user.station_id) return true;
        return user.station_id === row.station_id;
      }
      return false;
    },

    openOrderDetail(row) {
      this.detailOrder = {
        ...row,
        refund_status: this.getRefundStatus(row)
      };
      this.detailVisible = true;
    },

    async handleApplyRefund(row) {
      const rs = this.getRefundStatus(row);
      try {
        const { value } = await this.$prompt(
          `订单号：${row.order_no}\n金额：￥${Number(row.paid_amount || 0).toFixed(2)}\n\n请输入退款原因：`,
          rs === 'rejected' ? '重新申请退款' : '发起退款申请',
          {
            confirmButtonText: '提交申请',
            cancelButtonText: '取消',
            inputPlaceholder: '选填，如：客户投诉 / 重复支付',
            inputValue: row.refund_reason || '',
            inputType: 'textarea'
          }
        );

        const res = await this.$api.orders.refundApply({
          order_no: row.order_no,
          refundReason: (value || '').trim() || '管理员发起退款申请'
        });

        if (res && res.success) {
          this.$message.success('申请已提交，可点击"审批"进行审批');
          this.getData();
        } else {
          this.$message.error((res && res.message) || '提交失败');
        }
      } catch (e) {
        // 用户取消
      }
    },

    handleApproveCommand(row, command) {
      if (command === 'pass') {
        this.approvePass(row);
      } else if (command === 'reject') {
        this.approveReject(row);
      }
    },

    async approvePass(row) {
      try {
        await this.$confirm(
          `订单号：${row.order_no}\n实付金额：￥${Number(row.paid_amount || 0).toFixed(2)}\n\n确认通过该退款申请？`,
          '审批通过',
          {
            confirmButtonText: '确认通过',
            cancelButtonText: '取消',
            type: 'warning'
          }
        );
        const res = await this.$api.orders.refundApprove({ order_no: row.order_no });
        if (res && res.success) {
          this.$message.success('已通过审批，可点击"退款"执行退款');
          this.getData();
        } else {
          this.$message.error((res && res.message) || '操作失败');
        }
      } catch (e) {
        // 用户取消
      }
    },

    async approveReject(row) {
      try {
        const { value } = await this.$prompt('请输入驳回原因', '驳退回款', {
          confirmButtonText: '确认驳回',
          cancelButtonText: '取消',
          inputPlaceholder: '必填，用于告知申请人',
          inputType: 'textarea',
          inputValidator: (v) => (v && v.trim() ? true : '请填写驳回原因')
        });
        const res = await this.$api.orders.refundReject({
          order_no: row.order_no,
          rejectReason: value.trim()
        });
        if (res && res.success) {
          this.$message.success('已驳回');
          this.getData();
        } else {
          this.$message.error((res && res.message) || '操作失败');
        }
      } catch (e) {
        // 用户取消
      }
    },

    async handleRefund(row) {
      try {
        await this.$confirm(
          `确认对订单 ${row.order_no} 执行退款 ￥${Number(row.paid_amount || 0).toFixed(2)} ？\n退款后将无法撤销。`,
          '退款确认',
          {
            type: 'warning',
            confirmButtonText: '确认退款',
            cancelButtonText: '取消'
          }
        );

        const res = await this.$api.orders.refund({
          order_no: row.order_no,
          refundReason: row.refund_reason || '管理员退款'
        });

        if (res && res.success) {
          this.$message.success('退款成功');
          this.getData();
        } else {
          this.$message.error((res && res.message) || '退款失败');
        }
      } catch (e) {
        if (e !== 'cancel') {
          console.error('退款异常:', e);
        }
      }
    },

    getSummaries({ columns, data }) {
      const successData = data.filter(item => item.status === 'success');
      const sums = [];
      columns.forEach((column, index) => {
        const prop = column.property;
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (prop === 'weight' || prop === 'original_amount' || prop === 'discount_amount' || prop === 'settlement_amount' || prop === 'paid_amount' || prop === 'points') {
		  const values = successData.map(item => Number(item[prop]) || 0);
		  const total = values.reduce((a, b) => a + b, 0);
		  
		  // ★ 核心修复：针对不同字段做不同的精度处理
		  if (prop === 'weight') {
			sums[index] = total.toFixed(2); // 重量：保留 2 位小数
		  } else if (prop === 'points') {
			sums[index] = Math.round(total); // 积分：四舍五入取整
		  } else {
			sums[index] = '¥' + total.toFixed(2); // 其他金额：保留 2 位小数并加 ￥
		  }
		} else if (prop === 'withdraw_amount') {
          if (!this.canViewWithdrawAmount) {
              sums[index] = '';
              return;
            }
            const total = successData.reduce((sum, row) => sum + (Number(row.withdraw_amount) || 0), 0);
            sums[index] = '¥' + total.toFixed(3);
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
  },
};
</script>

<style scoped>
/* ================= 针对高度自适应和内部滚动的核心修复 ================= */
.flex-page-layout {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 120px); /* 减去顶部导航高度 */
  box-sizing: border-box;
}

.search-card {
  flex-shrink: 0;
  margin-bottom: 16px;
}

.table-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-bottom: 0;
}

/* 穿透 el-card__body 让内部也变成弹性布局 */
.table-card :deep(.el-card__body) {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 16px;
}

/* 包裹表格的容器，防止表格把卡片撑破 */
.table-container {
  flex: 1;
  overflow: hidden;
}

.pagination-wrapper {
  flex-shrink: 0;
  margin-top: 16px;
  display: flex;
  justify-content: center;
}

/* 修复 el-table 合计行被横向滚动条遮挡的问题 */
:deep(.el-table__footer-wrapper) {
  margin-bottom: 16px;
  z-index: 10;
}

.search-card .el-form-item { margin-bottom: 18px; }
.search-card .el-form { margin-bottom: -18px; }
.table-header { display: flex; justify-content: space-between; align-items: center; width: 100%; }
.table-header-right { display: flex; align-items: center; gap: 4px; }
:deep(.el-descriptions__label) { width: 110px; color: #666; }
:deep(.el-table .cell) .el-dropdown { vertical-align: middle; }
</style>